export default {
  name: 'ai-management',
  translationKey: 'ai-management-module',
  routePrefix: 'ai',
  routeNamePrefix: 'admin.ai-management',
  directRoutesAvailable: false,
}
